<div class="chat-participant">
    <form [formGroup]="form">
        <fieldset [disabled]="isSubmitting">
            <h1 mat-dialog-title>
                {{ 'ChatParticipants' | translate}}
            </h1>
            <div mat-dialog-content>
                <div  class="search-bar">
                  <mat-form-field color="primary">
                      <input matInput
                             type="text"
                             maxlength="255"
                             placeholder="{{ 'Filter' | translate }}"
                             (keyup)="userFilterKeyUp.next($event)" />
                      <mat-icon matSuffix>search</mat-icon>
                  </mat-form-field>
                </div>

                <div class="users-wrapper" *ngIf="!isLoading">
                    <mat-table [dataSource]="dataSource" matSort>
                        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                        <mat-row *matRowDef="let user; columns: columns"></mat-row>
                        <ng-container matColumnDef="user">
                            <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Name' | translate }}</mat-header-cell>
                            <mat-cell *matCellDef="let user; let i = index" class="name-cell" (click)="onUserSelected(user)">
                                <div fxLayout="row" fxLayoutAlign="start center" >
                                    <div>
                                        <img *ngIf="user.avatar" class="avatar" [src]="conf.storageRootUrl + user.avatar" />

                                        <i class="material-icons" *ngIf="!user.avatar">
                                            account_circle
                                        </i>
                                    </div>
                                    <div>
                                        {{ user.firstName }} {{ user.lastName }}
                                    </div>
                                </div>
                            </mat-cell>
                        </ng-container>

                        <!-- empty table message -->
                        <ng-template [ngIf]="dataSource.data.length === 0">
                            <mat-footer-row *matFooterRowDef="['noRecord']"></mat-footer-row>
                        </ng-template>
                        <ng-container matColumnDef="noRecord">
                            <mat-footer-cell *matFooterCellDef>{{ 'ChatNoParticipant' | translate }}</mat-footer-cell>
                        </ng-container>

                        <!--
                        <ng-container matColumnDef="action">
                            <mat-header-cell  mat-header-cell *matHeaderCellDef class="cell-right"></mat-header-cell>
                            <mat-cell mat-cell *matCellDef="let user; let i = index" class="cell-right">
                                <mat-checkbox  (click)="$event.stopPropagation()"
                                               (change)="$event ? selection.toggle(user.id) : null"
                                               [checked]="selection.isSelected(user.id)"
                                               >
                                </mat-checkbox>
                            </mat-cell>
                        </ng-container>
                        -->
                    </mat-table>
                    <mat-paginator
                       #matPaginator
                       [pageSizeOptions]="[10]"
                       hidePageSize
                       showFirstLastButtons
                       [pageSize]="paginator.per_page"
                       [length]="paginator.total"
                       [pageIndex]="paginator.current_page - 1"
                       (page)="onPaginateChange($event)"
                    >
                    </mat-paginator>
                </div>
            </div>
            <mat-dialog-actions>
                <!--
                <div fxLayout="column" fxLayoutAlign="center center" style="width:100%;">
                    <div class="discussion-name">

                        <div class="line line-margin">
                            <mat-form-field *ngIf="form.get('name')">
                                <mat-label class="required">{{ 'Name' | translate }}</mat-label>
                                <input matInput formControlName="name" class="required" autocomplete="off" maxlength="50">
                                <mat-error *ngIf="f.name.errors && f.name.errors.required">{{ 'Field_required' | translate }}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <button mat-button mat-dialog-close tabindex="-1">
                            {{ 'Cancel' | translate}}
                        </button>
                        <button mat-raised-button color="accent" (click)="onSave()" [disabled]="!selection.hasValue()">
                            {{ 'Save' | translate}}
                        </button>
                    </div>
                </div>
                -->

                <button mat-button mat-dialog-close tabindex="-1">
                    {{ 'Cancel' | translate}}
                </button>
            </mat-dialog-actions>
        </fieldset>
    </form>
</div>

